"use client";

function AdminMain({ children }: { children: React.ReactNode }) {
    return (
        <main className="card min-h-dvh w-full flex-1 overflow-y-auto p-4 sm:p-6 md:h-full md:max-h-full md:min-h-0 md:w-[calc(100%-300px)]">
            {children}
        </main>
    );
}
export default AdminMain;
